import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAdminData } from "../thunks/thunk-users";
import { User, Workout } from "../../constants/types";
// In your Redux slice:
const initialState: {
  userStatus: string;
  userError: string | null;
  user: {
    user: User[];
    userCount: number;
    workouts: Workout[];
    workoutsCount: number;
  } | null;
} = {
  userStatus: "idle",
  userError: null,
  user: null,
};

const data = createSlice({
  name: "data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminData.pending, (state) => {
        state.userStatus = "loading";
        state.userError = null;
      })
      .addCase(
        fetchAdminData.fulfilled,
        (
          state,
          action: PayloadAction<{
            users: { Items: User[]; Count: number };
            workouts: { Items: Workout[]; Count: number };
          }>
        ) => {
          state.userStatus = "succeeded";
          state.user = {
            user: action.payload.users.Items,
            userCount: action.payload.users.Count,
            workouts: action.payload.workouts.Items,
            workoutsCount: action.payload.workouts.Count,
          };
          state.userError = null;
        }
      )
      .addCase(fetchAdminData.rejected, (state, action) => {
        state.userStatus = "failed";
        state.userError = action.payload || "Failed to fetch user.";
      });
  },
});

export const {} = data.actions;
export default data.reducer;
